import kitchenInstance from '../instance'

const hideKitchenOrder = (orderId) => {
	return kitchenInstance.post('/orders/' + orderId + '/hide')
}

export default hideKitchenOrder
